import {useState} from "react";

export const useAddIntegrationCard = () => {
    const [hover, setHover] = useState<boolean>(false);
    return{
        hover,
        onMouseEnter: () => setHover(true),
        onMouseLeave: () => setHover(false)
    }
}